import { ref } from 'vue-demi';
import priceListApi from '../apis/priceList.api';
import queryParams from './pageQuery.service';
import store from '@/store';
const currentSeriesTransparentImg = ref('');
export function userSeriesCarLayer() {
  currentSeriesTransparentImg.value = '';
  const cityId = store.state.baseInfo.cityId || 0;
  const info = ref([]);
  async function selectOneCar(carInfo) {
    // 请求获取相应车型报价单接口,入参默认选全款不用传首付额度类型和还款年限
    // 设置报价单信息到store
    await store.dispatch('priceList/getPriceListAction', {
      cityId,
      specId: carInfo.SpecId,
      minPrice: carInfo.NewsPrice || carInfo.MinPrice,
      carPrice: carInfo.NewsPrice || carInfo.MinPrice,
    });
    // 设置相应车系信息到store;

    store.commit('priceList/setSpecInfo', {
      SpecId: carInfo.SpecId,
      SpecName: carInfo.SpecName,
      ImageUrl: carInfo.ImageUrl,
      MinPrice: carInfo.MinPrice,
      NewsPrice: carInfo.NewsPrice,
    });
    // 将一些信息重置
    store.commit('priceList/setResetInfo', {
      payType: 'full',
      prepaymentType: 1,
      loanTypeForYear: 3,
    });
  }
  function getOneActivity(list, type) {
    return (
      list &&
      list.length &&
      list
        .filter((item) => {
          return item.activity.type === type;
        })
        .sort((a, b) => {
          return b.activity.commodityPrice - a.activity.commodityPrice;
        })
    );
  }
  function getActivitiesFn(dealerId) {
    priceListApi.getActivities(dealerId).then((data) => {
      const shijiali = getOneActivity(data, 6);
      const daodianli = getOneActivity(data, 7);
      info.value = [];
      if (shijiali && shijiali.length) {
        info.value.push(shijiali[0]);
      }
      if (daodianli && daodianli.length) {
        info.value.push(daodianli[0]);
      }
      store.commit('priceList/setActivity', info.value);
    });
  }
  return {
    currentSeriesTransparentImg,
    selectOneCar,
    getActivitiesFn,
  };
}
